module.exports = __webpack_public_path__ + "img/ge.71b97434.svg";